import type { ProjectProfile, ProjectTrackingPlan } from '@shared/api-client';

export type RevenueProvider = 'stripe' | 'revenuecat';
type Platform = NonNullable<ProjectProfile['platform']>;
type RevenueSelection = ProjectTrackingPlan['revenue'];

export const allowedRevenueProviders = (
  platform: Platform,
): RevenueProvider[] =>
  platform === 'web'
    ? ['stripe']
    : platform === 'mobile'
      ? ['revenuecat']
      : ['stripe', 'revenuecat'];

export const normalizeRevenueSelection = (
  platform: Platform,
  revenue: RevenueSelection,
): RevenueSelection => {
  if (revenue === 'none' || revenue === 'undecided') {
    return revenue;
  }
  const allowed = allowedRevenueProviders(platform);
  if (revenue === 'both') {
    return allowed.length === 2 ? 'both' : 'undecided';
  }
  return allowed.includes(revenue) ? revenue : 'undecided';
};

export const revenueProvidersForSetup = (
  platform: Platform,
  revenue: RevenueSelection,
): RevenueProvider[] => {
  const normalized = normalizeRevenueSelection(platform, revenue);
  if (normalized === 'none') {
    return [];
  }
  const allowed = allowedRevenueProviders(platform);
  return normalized === 'undecided' || normalized === 'both'
    ? allowed
    : allowed.filter((provider) => provider === normalized);
};
